export default "__VITE_ASSET__DMdpsNFb__"